module.exports = __webpack_public_path__ + "static/media/tech-icons-tablet.6e6e7ca2.png";